<template>
  <BModal
    id="modal-edit-credential"
    centered
    hide-footer
    hide-header-close
    no-close-on-backdrop
    size="md"
    header-class="border-0 pb-0 pt-2 bg-white"
    body-class="px-2 pb-2 pt-2"
  >
    <template #modal-title>
      <span class="h3 text-dark font-weight-bold">Edit Data Credential</span>
    </template>

    <ValidationObserver ref="formObserver">
      <!-- Nama Platform -->
      <BFormGroup class="mb-2">
        <template
          #label
        >
          Nama Platform<span class="text-danger">*</span>
        </template>
        <ValidationProvider
          v-slot="{ errors }"
          name="Nama Platform"
          rules="required|max:50|platform_name"
        >
          <BFormInput
            v-model="form.platform"
            placeholder="Nama Platform"
            :state="errors.length > 0 ? false : null"
            :style="errors.length > 0 ? 'background-image: none' : ''"
          />
          <small
            class="text-danger d-flex align-items-center"
            style="gap: 4px;"
          >
            <img
              v-if="errors[0]"
              src="https://storage.googleapis.com/komerce/assets/icons/danger-red.svg"
              width="14"
              height="14"
            >
            {{ errors[0] }}
          </small>
        </ValidationProvider>
      </BFormGroup>

      <!-- URL Platform -->
      <BFormGroup class="mb-2">
        <template
          #label
        >
          URL Platform<span class="text-danger">*</span>
        </template>
        <ValidationProvider
          v-slot="{ errors }"
          name="URL Platform"
          rules="required|platform_url"
        >
          <BFormInput
            v-model="form.loginUrl"
            placeholder="Masukkan URL platform"
            :state="errors.length > 0 ? false : null"
            :style="errors.length > 0 ? 'background-image: none' : ''"
          />
          <small
            class="text-danger d-flex align-items-center"
            style="gap: 4px;"
          >
            <img
              v-if="errors[0]"
              src="https://storage.googleapis.com/komerce/assets/icons/danger-red.svg"
              width="14"
              height="14"
            >
            {{ errors[0] }}
          </small>
        </ValidationProvider>
      </BFormGroup>

      <!-- Username/Email -->
      <BFormGroup class="mb-2">
        <template
          #label
        >
          Username/Email<span class="text-danger">*</span>
        </template>
        <ValidationProvider
          v-slot="{ errors }"
          name="Username/Email"
          rules="required|min:3|max:100"
        >
          <BFormInput
            v-model.trim="form.email"
            placeholder="Masukkan Username/Email"
            :state="errors.length > 0 ? false : null"
            :style="errors.length > 0 ? 'background-image: none' : ''"
          />
          <small
            class="text-danger d-flex align-items-center"
            style="gap: 4px;"
          >
            <img
              v-if="errors[0]"
              src="https://storage.googleapis.com/komerce/assets/icons/danger-red.svg"
              width="14"
              height="14"
            >
            {{ errors[0] }}
          </small>
        </ValidationProvider>
      </BFormGroup>

      <!-- Password -->
      <BFormGroup class="mb-2">
        <template
          #label
        >
          Password<span class="text-danger">*</span>
        </template>

        <ValidationProvider
          v-slot="{ errors }"
          name="Password"
          rules="min:1|max:255"
        >
          <div class="position-relative">
            <BFormInput
              v-model="form.password"
              :type="showPassword ? 'text' : 'password'"
              :state="errors.length > 0 ? false : null"
              :style="errors.length > 0 ? 'background-image: none' : ''"
              @input="onPasswordInput"
            />
          </div>
          <small class="text-danger">{{ errors[0] }}</small>
        </ValidationProvider>
      </BFormGroup>

      <!-- Kategori -->
      <BFormGroup class="mb-2">
        <template
          #label
        >
          Kategori<span class="text-danger">*</span>
        </template>
        <ValidationProvider
          v-slot="{ errors }"
          name="Kategori"
          rules="required"
        >
          <BFormSelect
            v-model="form.category"
            :options="categories"
            value-field="value"
            text-field="label"
            :state="errors.length > 0 ? false : null"
            :style="errors.length > 0 ? 'background-image: none' : ''"
            class="custom-select-arrow"
            :class="{ 'placeholder-active': !form.category }"
          >
            <template #first>
              <BFormSelectOption
                value=""
                disabled
                hidden
              >
                Pilih kategori
              </BFormSelectOption>
            </template>
          </BFormSelect>
          <small
            class="text-danger d-flex align-items-center"
            style="gap: 4px;"
          >
            <img
              v-if="errors[0]"
              src="https://storage.googleapis.com/komerce/assets/icons/danger-red.svg"
              width="14"
              height="14"
            >
            {{ errors[0] }}
          </small>
        </ValidationProvider>
      </BFormGroup>

      <!-- Catatan -->
      <BFormGroup
        label="Catatan (Opsional)"
        class="mb-2"
      >
        <ValidationProvider
          v-slot="{ errors }"
          name="Catatan"
          rules="max_custom:500"
        >
          <BFormTextarea
            v-model="form.note"
            class="no-scrollbar"
            placeholder="Masukkan catatan tambahan seperti informasi PIN, atau pihak yang memegang OTP dan 2FA"
            rows="10"
            :state="errors.length > 0 ? false : null"
            :style="errors.length > 0 ? 'background-image: none' : ''"
          />

          <small
            class="text-danger d-flex align-items-center"
            style="gap: 4px;"
          >
            <img
              v-if="errors[0]"
              src="https://storage.googleapis.com/komerce/assets/icons/danger-red.svg"
              width="14"
              height="14"
            >
            {{ errors[0] }}
          </small>

          <div class="d-flex justify-content-end">
            <small :class="form.note.length >= 500 ? 'text-danger' : 'text-muted'">
              {{ form.note.length }}/500
            </small>
          </div>
        </ValidationProvider>
      </BFormGroup>

      <!-- Buttons -->
      <div
        class="d-flex"
        style="gap: 10px;"
      >
        <BButton
          variant="link"
          class="button-orange w-50"
          @click="handleCancle"
        >
          Batal
        </BButton>
        <BButton
          variant="link"
          :class="isDirty ? 'button-orange-active' : 'button-disabled'"
          class="w-50"
          :disabled="!isDirty || loading"
          @click="handleSave"
        >
          <BSpinner
            v-if="loading"
            small
          />
          <span v-else>Simpan</span>
        </BButton>
      </div>
    </ValidationObserver>
  </BModal>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { CATEGORIES_CREDENTIAL, credentialAxios } from './config'

export default {
  name: 'EditCredential',

  components: {
    ValidationObserver,
    ValidationProvider,
  },

  emits: ['updated', 'update-error', 'pin-expired-check', 'pin-session-expired'],

  data() {
    return {
      loading: false,
      originalForm: null,
      passwordChanged: false,
      showPassword: false,
      categories: CATEGORIES_CREDENTIAL,
      form: {
        id: null,
        platform: '',
        loginUrl: '',
        email: '',
        password: '',
        category: '',
        note: '',
      },
    }
  },

  computed: {
    isDirty() {
      if (!this.originalForm) return false
      const current = { ...this.form }
      const original = { ...this.originalForm }
      delete current.password
      delete original.password
      return JSON.stringify(current) !== JSON.stringify(original) || this.passwordChanged
    },
  },

  methods: {
    async handleSave() {
      const valid = await this.$refs.formObserver.validate()
      if (!valid) return

      this.$emit('pin-expired-check', {
        onValid: () => this.submitData(),
      })
    },

    onPasswordInput() {
      this.passwordChanged = this.form.password !== '**********'
    },

    buildPayload() {
      const payload = {
        platform_name: this.form.platform,
        platform_url: this.form.loginUrl,
        identifier: this.form.email,
        category: this.form.category,
        notes: this.form.note,
      }

      if (this.passwordChanged && this.form.password && this.form.password !== '**********') {
        payload.password = (this.form.password)
      }

      return payload
    },

    async submitData() {
      this.loading = true
      const payload = this.buildPayload()

      try {
        await credentialAxios.put(
          `v1/credential_management/secure/${this.form.id}`,
          payload,
        )

        this.$emit('updated')
        this.hide()
      } catch (err) {
        if (err.response?.status === 403) {
          this.hide()
          this.$emit('pin-session-expired', {
            onValid: () => this.submitData(),
          })
          return
        }
        this.$emit('update-error', err)
      } finally {
        this.loading = false
      }
    },

    handleCancle() {
      this.reset()
      this.hide()
    },

    reset() {
      this.form = {
        id: null,
        platform: '',
        loginUrl: '',
        email: '',
        password: '',
        category: '',
        note: '',
      }
      this.originalForm = null
      this.showPassword = false
      this.passwordChanged = false
      this.loading = false
      if (this.$refs.formObserver) this.$refs.formObserver.reset()
    },

    show(item) {
      this.reset()
      // pre-fill form dengan data yang dipilih
      this.form = {
        id: item.id,
        platform: item.platform,
        loginUrl: item.loginUrl,
        email: item.email,
        password: '**********',
        category: item.category || '',
        note: item.note || '',
      }
      // simpan snapshot original untuk dirty check
      this.originalForm = { ...this.form }
      this.$nextTick(() => {
        this.$bvModal.show('modal-edit-credential')
      })
    },

    hide() {
      this.$bvModal.hide('modal-edit-credential')
    },
  },
}
</script>

<style lang="scss" scoped>
@import './CredentialManagement.scss';

::v-deep select.custom-select.placeholder-active {
  color: #aab0b6 !important;
}
</style>
